import * as yup from 'yup'

export const Schema = (pharmacy, brandColor, secondBrandColor) =>  {
  const { branding, urls } = pharmacy;
  const { brand_colour, brand_colour_secondary, email_footer } = branding || {};
  const { android_link, app_link, ios_link, website } = urls || {};

  return {
    brandingLeft: {
      'Primary Colour': { defaultValue: brand_colour || '#', color: brandColor || brand_colour, field: 'branding.brand_colour', validation: yup.string().matches(/^#(?:[0-9a-f]{3}){1,2}$/i).required() },
      'Secondary Colour': { defaultValue: brand_colour_secondary || '#', color: secondBrandColor || brand_colour_secondary, field: 'branding.brand_colour_secondary', validation: yup.string().matches(/^#(?:[0-9a-f]{3}){1,2}$/i).required() },
      'Website': { defaultValue: website, field: 'urls.website', validation: yup.string().required() },
      'Email Footer Text': { defaultValue: email_footer, field: 'branding.email_footer', validation: yup.string() },
    },
    mobileAppLinksLeft: {
      'iOS App Link': { defaultValue: ios_link, field: 'urls.ios_link', validation: yup.string().required() },
      'Universal App Link': { defaultValue: app_link, field: 'urls.app_link', validation: yup.string().required() }
    },
    mobileAppLinksRight: {
      'Android App Link': { defaultValue: android_link, field: 'urls.android_link', validation: yup.string().required() }
    }
  }
}
